import React from 'react';
import styles from '../../assets/styles/Admin/AdminShell.module.scss';
import MimaText from '../MimaText';

export const MetricGroup = ({ metrics }) => {
	return (
		<div className={styles.metric__group}>
			{metrics?.map((item, i) => (
				<div key={i} className={styles.metric__card}>
					<MimaText variant="small" mb={2}>
						{item?.label}
					</MimaText>
					<MimaText variant="h3">{item?.value}</MimaText>
				</div>
			))}
		</div>
	);
};

export default MetricGroup;
